import type { InvoiceDate } from '@vy/types';
import { vySerialize } from '@vy/utils';
import { useStateParams } from '../../../hooks/use-state-params';
import { DEFAULT_INVOICES_TABLE_SELECTED_MONTHS } from '../InvoicesPage/invoices-page-consts';

export function useDatesParam() {
  return useStateParams<InvoiceDate[]>(
    DEFAULT_INVOICES_TABLE_SELECTED_MONTHS,
    'dates',
    serializeInvoiceDates,
    deserializeInvoiceDates,
  );
}

function serializeInvoiceDates(dates: InvoiceDate[]) {
  return vySerialize(dates);
}

function deserializeInvoiceDates(datesString: string) {
  return JSON.parse(datesString);
}
